import { Box } from '@chakra-ui/react';
import React from 'react';
import { CustomText } from '../atoms/CustomText';

interface ArticleCardProps {
  id: string | number;
  title: string;
  body?: string;
  faqArticlesBgColor: string;
  faqArticlesTextColor: string;
  onClickPopularArticle: (id: string | number) => void;
  faqBodyCharLimit: number;
  popularArticleHref?: (id: string | number) => string;
}

export const ArticleCard: React.FC<ArticleCardProps> = ({
  id,
  title,
  body = '',
  faqArticlesBgColor,
  faqArticlesTextColor,
  onClickPopularArticle,
  faqBodyCharLimit = 400,
  popularArticleHref,
}) => {
  const sanitizedBody = body.replace(/<img[^>]*>/g, '');
  const truncatedBody =
    sanitizedBody.length > faqBodyCharLimit
      ? `${sanitizedBody.slice(0, faqBodyCharLimit)}...`
      : sanitizedBody;

  return (
    <a
      href={popularArticleHref ? popularArticleHref(id) : undefined}
      style={{ textDecoration: 'none' }}
    >
      <Box
        pt="4"
        pb="4"
        px="5"
        boxShadow="sm"
        _hover={{ boxShadow: 'md', transform: 'scale(1.05)' }}
        cursor="pointer"
        maxW="100%"
        bg={faqArticlesBgColor}
        onClick={e => {
          const isLeftClick = e.button === 0;
          const isModifiedClick = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
          // SPA routing on normal click
          if (isLeftClick && !isModifiedClick) {
            e.preventDefault();
            onClickPopularArticle(id);
          }
        }}
      >
        {/* Article Title */}
        <CustomText variant="h3" fontSize="lg" fontWeight="bold" color={faqArticlesTextColor}>
          {title}
        </CustomText>

        {/* Article Body (filtered and NOT truncated) */}
        <Box
          mt="3"
          fontSize="sm"
          fontWeight="normal"
          color={faqArticlesTextColor}
          dangerouslySetInnerHTML={{
            __html: truncatedBody,
          }}
        />
      </Box>
    </a>
  );
};
